import { useState } from "react";
import { Phone, ChevronRight, CheckCircle2, ShieldCheck, Star, ArrowRight, Ruler } from "lucide-react";
import { Link } from "@/components/common/Link";

// === Update these paths after uploading installation hero image to 10Web Media Library ===
// Suggestion: photo of a freshly installed premium garage door (modern home with sectional/roller door).
const HERO_IMG = {
  desktop: "/wp-content/uploads/installation-hero-desktop.webp",
  tablet: "/wp-content/uploads/installation-hero-tablet.webp",
  mobile: "/wp-content/uploads/installation-hero-mobile.webp"
};
const NAVY = "#081438";
const NAVY_LIGHT = "#243752";
const GOLD = "#F5A623";
const FONT_HEAD = "'Plus Jakarta Sans', system-ui, sans-serif";
const FONT_BODY = "'Manrope', system-ui, sans-serif";
export default function InstallationHero() {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const name = data.get("name");
    const phone = data.get("phone");
    const suburb = data.get("suburb");
    const service = data.get("service");
    const wa = `https://wa.me/61485000933?text=${encodeURIComponent(`Hi Gold Garage Door, I'd like a quote on a new door installation.\nName: ${name}\nPhone: ${phone}\nSuburb: ${suburb}\nProject: ${service}`)}`;
    setSubmitted(true);
    setTimeout(() => {
      window.location.href = wa;
    }, 600);
  };
  return;
}

/* === Field components === */

function Field({
  name,
  label,
  type,
  placeholder,
  required
}: {
  name: string;
  label: string;
  type: string;
  placeholder: string;
  required?: boolean;
}) {
  return <label className="block">
      <span className="block text-[11px] font-semibold uppercase tracking-wider mb-1.5" style={{
      fontFamily: FONT_BODY,
      color: "rgba(255,255,255,0.75)"
    }}>
        {label}
      </span>
      <input name={name} type={type} placeholder={placeholder} required={required} className="w-full rounded-lg border px-4 py-2.5 text-[15px] text-white placeholder:text-white/35 outline-none transition-all" style={{
      fontFamily: FONT_BODY,
      backgroundColor: "rgba(255,255,255,0.06)",
      borderColor: "rgba(255,255,255,0.15)"
    }} onFocus={e => {
      e.currentTarget.style.borderColor = GOLD;
      e.currentTarget.style.boxShadow = `0 0 0 3px ${GOLD}33`;
    }} onBlur={e => {
      e.currentTarget.style.borderColor = "rgba(255,255,255,0.15)";
      e.currentTarget.style.boxShadow = "none";
    }} />
    </label>;
}
function SelectField({
  name,
  label,
  defaultValue,
  options
}: {
  name: string;
  label: string;
  defaultValue: string;
  options: string[];
}) {
  return <label className="block">
      <span className="block text-[11px] font-semibold uppercase tracking-wider mb-1.5" style={{
      fontFamily: FONT_BODY,
      color: "rgba(255,255,255,0.75)"
    }}>
        {label}
      </span>
      <select name={name} defaultValue={defaultValue} className="w-full rounded-lg border px-4 py-2.5 text-[15px] text-white outline-none transition-all appearance-none cursor-pointer" style={{
      fontFamily: FONT_BODY,
      backgroundColor: "rgba(255,255,255,0.06)",
      borderColor: "rgba(255,255,255,0.15)",
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23F5A623' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'/></svg>\")",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 14px center",
      paddingRight: "40px"
    }} onFocus={e => {
      e.currentTarget.style.borderColor = GOLD;
      e.currentTarget.style.boxShadow = `0 0 0 3px ${GOLD}33`;
    }} onBlur={e => {
      e.currentTarget.style.borderColor = "rgba(255,255,255,0.15)";
      e.currentTarget.style.boxShadow = "none";
    }}>
        {options.map(opt => <option key={opt} value={opt} style={{
        backgroundColor: NAVY,
        color: "white"
      }}>
            {opt}
          </option>)}
      </select>
    </label>;
}